import { DEBUG, getAppsGatewayUrl } from '../../../../../../../constants/env';
import { WORKFLOW_IDS } from './constants';
import type { FetchInvokeRequest } from './types';

interface FetchCustomerParams {
  jwt: string;
  sessionId: string;
  retailerMoniker: string;
  orderNumber?: string;
  trackingNumber?: string;
}

export interface FetchCustomerResult {
  email: string | null;
  zip: string | null;
}

export async function fetchCustomer(
  params: FetchCustomerParams,
): Promise<FetchCustomerResult | null> {
  const { jwt, sessionId, retailerMoniker, orderNumber, trackingNumber } =
    params;

  if (!orderNumber && !trackingNumber) return null;

  const invokeRequest: FetchInvokeRequest = {
    workflowId: WORKFLOW_IDS.FETCH_CUSTOMER,
    context: { sessionId, retailerMoniker, orderNumber, trackingNumber },
    body: {},
  };

  try {
    const res = await fetch(`${getAppsGatewayUrl()}/invoke`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(invokeRequest),
    });
    if (!res.ok) return null;
    const { data } = (await res.json()) as { data: FetchCustomerResult };
    return data ?? null;
  } catch (err) {
    if (DEBUG) console.warn('Fetch customer prefill unavailable:', err);
    return null;
  }
}
